import { isSuccess } from '@/context/services/type';
import { isCommonError } from '@/libs/typeguard/isError';
import type {
  InvoiceReportDetailJournalEntriesResponse,
  InvoiceReportJournalResponse,
} from 'ap-openapi';
import { useGetAdminInvoiceReportJournalSuspense } from 'ap-openapi';
import { useMemo } from 'react';

export type { InvoiceReportDetailJournalEntriesResponse };

type FetchAdminInvoiceReportJournalEntriesResult = {
  data?: InvoiceReportJournalResponse;
  error?: {
    messages?: string[];
    code?: string;
  };
};

export const useAdminInvoiceReportJournalEntries = (
  reportId: string
): FetchAdminInvoiceReportJournalEntriesResult => {
  const { data, error } = useGetAdminInvoiceReportJournalSuspense(reportId, {
    query: {
      queryKey: ['adminInvoiceReportJournalEntries', reportId],
    },
  });

  if (error) {
    throw error;
  }

  const body = data?.data;
  const status = data?.status;
  const isSuccessStatus = isSuccess(status);

  return useMemo(() => {
    if (!isSuccessStatus) {
      return {
        error: {
          messages:
            typeof body === 'object' && isCommonError(body)
              ? body.messages
              : undefined,
          code: status?.toString(),
        },
      };
    }
    return {
      data: body,
    };
  }, [body, status, isSuccessStatus]);
};
